import { Component, OnInit } from "@angular/core";

@Component({
	selector: "app-substitution-maintenance",
	templateUrl: "./substitution-maintenance.component.html",
	styleUrls: ["./substitution-maintenance.component.css"],
})
export class SubstitutionMaintenanceComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}

	////////////////////////////////////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////////////////////////////////////

	PersonID: any = -1;
	SelectedPerson: any;

	HistoryExpand: any = false;

	////////////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////////////
	// Events
	////////////////////////////////////////////////////////////////////////////////

	onPersonSelected(val) {
		this.SelectedPerson = val;

		if (this.SelectedPerson != null) {
			this.PersonID = this.SelectedPerson.PersonID;
		} else {
			this.PersonID = -1;
		}
	}

	////////////////////////////////////////////////////////////////////////////////
}
